import React, { Suspense } from 'react'
import { ToastAlertProvider } from '@design-systems/canvas-ui'
import {
  AUDIENCE_INTERNAL,
  RFI_TYPE_LOCATION,
  RFI_TYPE_QUESTIONNAIRE,
  MANUFACTURING_TYPE_ID_PACKAGING,
  COMMENTS_MAX_LENGTH,
  TARGET,
} from '../../../../common/commonConstants'
import {
  EmailModal,
  RFI3ReviewPageModal,
  BypassRFI3Modal,
  RFIAuditCommentsDrawer,
  RfiFormApprovalConfirmationModal,
} from '../../../../globalComponents/RfiCommons/popup'
import { BackgroundOverlay } from '../../../../common'
import { getCapabilityPopupSpecification } from '../../../../globalComponents/RfiConstants'

const RfiProductCapabilitiesConfimationModalLazy = React.lazy(() =>
  import('../../../../globalComponents/RfiCommons/popup').then((mod) => ({
    default: mod.RfiProductCapabilitiesConfimationModal,
  })),
)

const Rfi3Modals = ({
  isShowEmailDialog,
  closeEmailDialog,
  isShowConfirmation,
  userAction,
  userComments,
  setUserComments,
  commentsMaxLen,
  closeRFIActionConfirmationModal,
  onActionConfirmation,
  rfi3Data,
  supplierId,
  locationId,
  manufacturingTypeId,
  isCommentsOpen,
  setIsCommentsOpen,
  isAuditTrailOpen,
  setIsAuditTrailOpen,
  refreshRFI3Screen,
  onLastRfi3ActivityChange,
  isShowBypass,
  setIsShowBypass,
  confirmBypassReaction,
  isFastTrackInProgress,
  isFastTrackFailed,
  isRfiNextActionPCInProgress,
  isRfiNextActionPCFailed,
  productCapabilityDialogSettings,
  closeRFIProductCapabilitiesConfirmationModal,
  onCapabilityNextActionConfirmation,
  isShowOverlay,
  commentsTab,
  handleCloseBypassModal,
}) => {
  return (
    <>
      <ToastAlertProvider>
        <RFI3ReviewPageModal />
      </ToastAlertProvider>

      <EmailModal
        isVisible={isShowEmailDialog}
        closeEmailDialog={closeEmailDialog}
        supplierId={rfi3Data?.supplier_id}
        locationId={rfi3Data?.location_id}
        manufacturingTypeId={rfi3Data?.manufacturing_type_id}
        rfiType={RFI_TYPE_LOCATION}
        audience={AUDIENCE_INTERNAL}
      />

      <RfiFormApprovalConfirmationModal
        isVisible={isShowConfirmation}
        rfiType={RFI_TYPE_LOCATION}
        userAction={userAction}
        userComments={userComments}
        setUserCommentsValue={(event) => {
          if (event.target.value.length <= commentsMaxLen) {
            setUserComments(event.target.value)
          }
        }}
        commentsMaxLen={commentsMaxLen}
        closeRFIActionConfirmationModal={closeRFIActionConfirmationModal}
        onActionConfirmation={onActionConfirmation}
        manufacturingTypeId={rfi3Data?.manufacturing_type_id}
      />

      <RFIAuditCommentsDrawer
        rfiType={RFI_TYPE_LOCATION}
        supplierId={supplierId}
        supplierName={rfi3Data?.supplier_name}
        locationId={locationId}
        locationName={
          rfi3Data?.fixed_sections?.factory_contact_information?.location_name
        }
        manufacturingType={rfi3Data?.manufacturing_type}
        manufacturingTypeId={manufacturingTypeId}
        view={TARGET}
        isCommentsDrawerOpen={isCommentsOpen}
        focusCommentTab={commentsTab}
        isAuditTrailDrawerOpen={isAuditTrailOpen}
        closeCommentsDrawer={() => setIsCommentsOpen(false)}
        closeAuditTrailDrawer={() => setIsAuditTrailOpen(false)}
        getLastRFI3Activity={onLastRfi3ActivityChange}
        refreshRFIScreen={refreshRFI3Screen}
      />

      <BypassRFI3Modal
        isVisible={isShowBypass}
        closeBypassModal={handleCloseBypassModal}
        commentsMaxLen={commentsMaxLen}
        updateBypassReaction={confirmBypassReaction}
      />

      {manufacturingTypeId === MANUFACTURING_TYPE_ID_PACKAGING && (
        <Suspense fallback={null}>
          <RfiProductCapabilitiesConfimationModalLazy
            isRfiNextActionPCInProgress={isRfiNextActionPCInProgress}
            isRfiNextActionPCFailed={isRfiNextActionPCFailed}
            closeRFIProductCapabilitiesConfirmationModal={
              closeRFIProductCapabilitiesConfirmationModal
            }
            commentsMaxLen={COMMENTS_MAX_LENGTH}
            settings={productCapabilityDialogSettings}
            capabilitiesList={rfi3Data?.capability_vetting_status}
            existingComment={rfi3Data?.vetting_status_comments}
            userComments={userComments || ''}
            onNextActionConfirmation={onCapabilityNextActionConfirmation}
            manufacturingTypeId={manufacturingTypeId}
            rfiType={RFI_TYPE_QUESTIONNAIRE}
            specifications={getCapabilityPopupSpecification(
              RFI_TYPE_QUESTIONNAIRE,
              manufacturingTypeId,
            )}
            isCapabilityManagementMode={!userAction}
          />
        </Suspense>
      )}

      {isShowOverlay && <BackgroundOverlay showSpinner />}
    </>
  )
}

export default React.memo(Rfi3Modals)
